"use client";

import { useState } from "react";
import { Carousel, Modal } from "@forestsync/ui";

interface ProjectPhotoCarouselProps {
  urls: string[];
  name: string;
}

export function ProjectPhotoCarousel({ urls, name }: ProjectPhotoCarouselProps) {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const openLightbox = (index: number) => {
    setLightboxIndex(index);
    setLightboxOpen(true);
  };

  return (
    <>
      <Carousel
        slideSize={{ base: "50%", sm: "33.333%", md: "25%" }}
        slideGap="xs"
        emblaOptions={{ loop: true, align: "start" }}
        withControls={urls.length > 1}
        withIndicators={false}
      >
        {urls.map((url, i) => (
          <Carousel.Slide key={i}>
            <img
              src={url}
              alt={`${name} photo ${i + 1}`}
              onClick={() => openLightbox(i)}
              style={{
                width: "100%",
                height: 160,
                objectFit: "cover",
                borderRadius: 6,
                cursor: "pointer",
                display: "block",
              }}
            />
          </Carousel.Slide>
        ))}
      </Carousel>

      <Modal
        opened={lightboxOpen}
        onClose={() => setLightboxOpen(false)}
        size="xl"
        centered
        withCloseButton
        padding={0}
        styles={{ body: { padding: 0 } }}
      >
        <Carousel
          initialSlide={lightboxIndex}
          emblaOptions={{ loop: true }}
          withControls
          withIndicators
          height={560}
        >
          {urls.map((url, i) => (
            <Carousel.Slide key={i}>
              <img
                src={url}
                alt={`${name} photo ${i + 1}`}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  display: "block",
                  background: "var(--mantine-color-dark-7, #000)",
                }}
              />
            </Carousel.Slide>
          ))}
        </Carousel>
      </Modal>
    </>
  );
}
